import { render, staticRenderFns } from "./HNav.vue?vue&type=template&id=5838436a&scoped=true&"
import script from "./HNav.vue?vue&type=script&lang=js&"
export * from "./HNav.vue?vue&type=script&lang=js&"
import style0 from "./HNav.vue?vue&type=style&index=0&id=5838436a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5838436a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5838436a')) {
      api.createRecord('5838436a', component.options)
    } else {
      api.reload('5838436a', component.options)
    }
    module.hot.accept("./HNav.vue?vue&type=template&id=5838436a&scoped=true&", function () {
      api.rerender('5838436a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HNav.vue"
export default component.exports